import axios from 'axios';

// const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
// const UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;
const CLOUD_NAME = 'djm7lrihj';
const UPLOAD_PRESET = 'document_thumbnails';

const UPLOAD_URL = `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`;
const DEFAULT_UPLOAD_ERROR = 'Failed to upload image';

const getUploadErrorMessage = (error) => {
  return (
    error?.response?.data?.error?.message ||
    error?.response?.data?.message ||
    error?.message ||
    DEFAULT_UPLOAD_ERROR
  );
};

/**
 * Normalizes a data URL string to a File for multipart upload.
 * @param {string} dataUrl
 * @returns {Promise<File>}
 */
async function dataUrlToFile(dataUrl) {
  const res = await fetch(dataUrl);
  const blob = await res.blob();
  const mime = blob.type || 'image/png';
  const ext = mime.includes('png') ? 'png' : mime.includes('webp') ? 'webp' : 'jpg';
  return new File([blob], `upload.${ext}`, { type: mime });
}

/**
 * Uploads a base64 PNG data URL or File/Blob to Cloudinary and returns the secure URL.
 * @param {string|File|Blob} image - data URL, File, or Blob
 * @returns {Promise<string>} The secure URL of the uploaded image
 */
export async function uploadToCloudinary(image) {
  if (!CLOUD_NAME || !UPLOAD_PRESET) {
    throw new Error('Cloudinary configuration missing.');
  }

  let file = image;
  if (typeof image === 'string' && image.startsWith('data:')) {
    file = await dataUrlToFile(image);
  } else if (image instanceof Blob && !(image instanceof File)) {
    file = new File([image], 'upload.jpg', { type: image.type || 'image/jpeg' });
  }

  const formData = new FormData();
  formData.append('upload_preset', UPLOAD_PRESET);
  formData.append('file', file);

  try {
    const res = await axios.post(UPLOAD_URL, formData);
    return res.data.secure_url;
  } catch (error) {
    throw new Error(getUploadErrorMessage(error));
  }
}
